import { render } from "./DeployButtons.vue?vue&type=template&id=718e33cc&scoped=true"
import script from "./DeployButtons.vue?vue&type=script&lang=js"
export * from "./DeployButtons.vue?vue&type=script&lang=js"

import "./DeployButtons.vue?vue&type=style&index=0&id=718e33cc&lang=less&scoped=true"
import "./DeployButtons.vue?vue&type=style&index=1&id=718e33cc&lang=less"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718e33cc"]])

export default __exports__